import { apiService } from 'services'

import { IPaymentData, SubscriptionResponse } from 'types'

const URL = '/subscriptions'

const getActiveSubscription = async () => apiService.get<SubscriptionResponse>(`${URL}/active`)

const subscribe = async (data: IPaymentData) =>
  apiService.post<string>(URL, {
    plan: data.type,
    data: {
      phone: data.phone,
    },
  })

export const SubscriptionApi = { getActiveSubscription, subscribe }
